import { HttpClient } from '@angular/common/http';
import { Provider } from '@angular/core';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';

import { CustomTranslateLoader } from './custom-translation-loader';

export interface CelumTranslationsOptions {
  locales?: string[];
  prefix?: string | (() => string);
}

export function provideCelumTranslations(options?: CelumTranslationsOptions): Provider[] {
  const translationIdentifiers = ['', ...(options?.locales ?? []).filter(locale => locale)];

  return provideTranslateService({
    loader: {
      provide: TranslateLoader,
      useFactory: (http: HttpClient) =>
        new CustomTranslateLoader(http, translationIdentifiers, false, typeof options?.prefix === 'function' ? options.prefix() : (options?.prefix ?? '')),
      deps: [HttpClient]
    }
  });
}
